<script>
  import { onMount } from 'svelte';
  import { phoneWidth } from '../stores.js';

  export let id = '';
  let top;
  let scrollY;
  // const marginTop = window.innerWidth < $phoneWidth ? 100 : 80;
  const marginTop = 100;
  const offset = 100;
  const _elem = () => document.querySelector('#' + id);
  const handleOpacity = () => {
    const elem = _elem();
    top = elem.getBoundingClientRect().top + document.documentElement.scrollTop;
    if (Math.abs(scrollY - top) < marginTop + offset) {
      elem.style.opacity = '0';
    } else {
      elem.style.opacity = '1';
    }
  };
</script>

<svelte:window on:scroll={handleOpacity} bind:scrollY />

<div {id} class="container">
  <span class="line-separator" />
</div>

<style>
  .container {
    transition: 0.3s;
    display: block;
  }
  .line-separator {
    display: block;
    margin: 100px auto;
    width: 50px;
    border-top: 3px solid #666;
  }
  @media screen and (max-width: 768px) {
    .line-separator {
      margin: 100px auto;
      width: 30px;
      border-top: 1px solid #666;
    }
  }
</style>
